import Prism from 'prismjs';
import React from 'react'
// import PrismDecorator from 'draft-js-prism'
import PrismDecorator from './decorator';
import { useDispatch, useSelector } from 'react-redux'

const defaultFilter =(block)=> {
    return block.getType() === 'code-block';
}

const defaultGetSyntax = (block)=> {
    if (block.getData) {
        return block.getData().get('syntax');
    }
    return null;
}

const defaultRender =(props)=> {
    return React.createElement(
        "span",
        { className: `prism-token ${props.theme} token ${props.type}`},
        props.children
    );
}


const PrismOptions = {
    // Default language to use
    defaultSyntax:      'javascript',
    // Theme for syntax
    theme:              'dark',
    // Filter block before highlighting
    filter:             defaultFilter,
    // Function to get syntax for a block
    getSyntax:          defaultGetSyntax,
    // Render a decorated text for a token
    render:             defaultRender,
    // Prism module
    prism:              Prism
}

export const PrismDraftDecorator = (options={})=> {
    return new PrismDecorator( Object.assign(options, PrismOptions) ) 
}